import { useState, useRef, useEffect } from "react";

const Dropdown = ({
  options,
  selected,
  onChange,
  placeholder = "Select",
  labelKey = "label",
  valueKey = "value",
  style,
  styling,
  renderLabel,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggle = () => setOpen((prev) => !prev);

  const handleSelect = (value) => {
    onChange(value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getSelectedLabel = () => {
    if (!selected && selected !== 0) return placeholder;
    const selectedOption = options.find(
      (opt) => String(opt[valueKey]) === String(selected),
    );
    if (!selectedOption) return placeholder;
    return renderLabel ? renderLabel(selectedOption) : selectedOption[labelKey];
  };

  return (
    <div ref={ref} className={`relative w-full bg-white ${style} ${styling}`}>
      <button
        type="button"
        onClick={toggle}
        className="flex justify-between items-center primary-input"
      >
        <span
          className={`text-[0.8rem] ${selected ? "text-gray-800 font-medium" : "text-gray-400 font-normal"}`}
        >
          {getSelectedLabel()}
        </span>
        <svg
          className={`fill-current h-4 w-4 ml-2 transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
        </svg>
      </button>

      {open && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-2xl scrollbar-hide py-2 my-2 shadow-lg max-h-60 overflow-auto">
          {options.length > 0 ? (
            options.map((option) => (
              <li
                key={option[valueKey]}
                className="px-4 py-2 font-semibold text-gray-700 text-xs hover:bg-gray-50 cursor-pointer border-gray-100"
                onClick={() => handleSelect(option[valueKey])}
              >
                {renderLabel ? renderLabel(option) : option[labelKey]}
              </li>
            ))
          ) : (
            <li className="px-4 py-2 text-gray-400 cursor-default">
              No data available
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
